export default __webpack_public_path__ + "static/media/logo-us-amazon.af2bc743.svg";